"use strict";
var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");

var SnapSet = require("./../extensions/snap/snapSet.js");
var SnapLineType = require("./../extensions/snap/snapLineType.js");

/**
 (normal grid layout)
 [1]   [2]   [3]

 [4]   [5]   [6]

 [7]   [8]   [9]

 (horiz flipping)
 [3]   [2]   [1]

 [6]   [5]   [4]

 [9]   [8]   [7]

 (vert flipping)
 [7]   [8]   [9]

 [4]   [5]   [6]

 [1]   [2]   [3]

 (horiz and vert flipping)
 [9]   [8]   [7]

 [6]   [5]   [4]

 [3]   [2]   [1]
 */

var GridInteractionHandle = function (gridInteractionModel, handleGridIndex) {
    var self = this;

    this.makeObservableTreeNode();

    this.handleGridIndex = handleGridIndex;

    this.gridInteractionModel = gridInteractionModel;

    this.selected = this.value("selected", true);
    this.highlighted = this.value("highlighted", true);
    this.hidden = this.value("hidden", true);

    this.precision = this.gridInteractionModel.precision;

    this.pos = this.shadow("pos",
        function () {
            var pos = this.gridInteractionModel.gPos() || new lib_geometry.Coord(0,0);
            var width = this.gridInteractionModel.gWidth() || 0;
            var height = this.gridInteractionModel.gHeight() || 0;
            var angle = this.gridInteractionModel.gAngle() || 0;
            var xflip = this.gridInteractionModel.gXflip() || false;
            var yflip = this.gridInteractionModel.gYflip() || false;

            var xFactor = xflip ? -1 : 1;
            var yFactor = yflip ? -1 : 1;
            switch (this.handleGridIndex) {
                case 1:
                    return new lib_geometry.Coord(pos.x-xFactor*width/2, pos.y-yFactor*height/2).rotate(angle, pos);
                case 2:
                    return new lib_geometry.Coord(pos.x, pos.y-yFactor*height/2).rotate(angle, pos);
                case 3:
                    return new lib_geometry.Coord(pos.x+xFactor*width/2, pos.y-yFactor*height/2).rotate(angle, pos);
                case 4:
                    return new lib_geometry.Coord(pos.x-xFactor*width/2, pos.y).rotate(angle, pos);
                case 5:
                    return pos;
                case 6:
                    return new lib_geometry.Coord(pos.x+xFactor*width/2, pos.y).rotate(angle, pos);
                case 7:
                    return new lib_geometry.Coord(pos.x-xFactor*width/2, pos.y+yFactor*height/2).rotate(angle, pos);
                case 8:
                    return new lib_geometry.Coord(pos.x, pos.y+yFactor*height/2).rotate(angle, pos);
                case 9:
                    return new lib_geometry.Coord(pos.x+xFactor*width/2, pos.y+yFactor*height/2).rotate(angle, pos);
                default:
                    throw new Error("unknown handle index!");
            }
            return pos;
        },
        null,
        [this.gridInteractionModel.gPos,
         this.gridInteractionModel.gWidth,
         this.gridInteractionModel.gHeight,
         this.gridInteractionModel.gAngle,
         this.gridInteractionModel.gXflip,
         this.gridInteractionModel.gYflip]
    );

    this.highlighted.onChange("highlighted", function (member, old, value) {
        if(value) self.gridInteractionModel.unhighlightAllExcept(self.handleGridIndex);
    });
};
lib_core.mixin(GridInteractionHandle, lib_core.ObservableTreeNode);
lib_core.JsonParser.registerClass(GridInteractionHandle, "GridInteractionHandle");

module.exports = GridInteractionHandle;

GridInteractionHandle.prototype.setSelected = function (selected) {
    this.selected(selected);
};

GridInteractionHandle.prototype.getSnapSet = function (type) {
    var snapSet = new SnapSet();
    if (!this.pos()) return snapSet;

    switch (type) {
        case SnapLineType.TO:
            snapSet.addHor(this.pos(), 1, 0, null, this.parent(), 0, "handle");
            snapSet.addVer(this.pos(), 1, 0, null, this.parent(), 0, "handle");
            break;
        case SnapLineType.FROM:
            snapSet.add(this.pos(), 1, 0, null, this.parent(), 0, "handle");
            break;
    }

    return snapSet;
};

GridInteractionHandle.prototype.update = function() {
    this.hidden(this.gridInteractionModel.hidden());

    if(this.hidden()) {
        this.highlighted(!this.hidden());
        return;
    }

    var pos = this.gridInteractionModel.gPos();
    var width = this.gridInteractionModel.gWidth();
    var height = this.gridInteractionModel.gHeight();

    switch (this.handleGridIndex) {
        case 1:
            if(width < this.precision) this.hidden(true);
            if(height < this.precision) this.hidden(true);
            break;
        case 2:
            if(height < this.precision) this.hidden(true);
            break;
        case 3:
            if(width < this.precision) this.hidden(true);
            if(height < this.precision) this.hidden(true);
            break;
        case 4:
            if(width < this.precision) this.hidden(true);
            break;
        case 5:
            break;
        case 6:
            if(width < this.precision) this.hidden(true);
            break;
        case 7:
            if(width < this.precision) this.hidden(true);
            if(height < this.precision) this.hidden(true);
            break;
        case 8:
            if(height < this.precision) this.hidden(true);
            break;
        case 9:
            if(width < this.precision) this.hidden(true);
            if(height < this.precision) this.hidden(true);
            break;
        default:
            throw new Error("unknown handle index!");
    }
};

GridInteractionHandle.prototype.onElementMovingStart = function() {
    this.gridInteractionModel.update();
    this.gridInteractionModel.handleMoving = true;
    if(this.highlighted()) {
        this.absVec = new lib_geometry.Coord(0,0);
        this.refPos = this.gridInteractionModel.gPos();
        this.refWidth = this.gridInteractionModel.gWidth();
        this.refHeight = this.gridInteractionModel.gHeight();
        this.refAngle = this.gridInteractionModel.gAngle();
    }
};

GridInteractionHandle.prototype.move = function (vec, keys) {
    var self = this;
    var im = self.gridInteractionModel;

    if(!this.highlighted()) return;

    this.absVec = this.absVec.add(vec);

    vec = this.absVec.copy();

    var centerMode = keys.altKey;
    var shiftMode = keys.shiftKey;

    var posOnly = false;
    var width = this.refWidth;
    var height = this.refHeight;
    var angle = this.refAngle;
    var factor = centerMode ? 2 : 1;
    var dimVec = new lib_geometry.Coord(width, height);
    var diagDir = dimVec.mult(1/dimVec.length());

    var vFilter = new lib_geometry.Coord(0,1);
    var hFilter = new lib_geometry.Coord(1,0);

    switch (this.handleGridIndex) {
        case 1:
            var dir = diagDir.rotate(angle).mult(-1,-1);
            if(shiftMode) vec = dir.mult(vec.dot(dir) / dir.dot(dir));
            var rVec = vec.rotate(-angle).mult(factor, factor);
            width = this.refWidth - rVec.x;
            height = this.refHeight - rVec.y;
            break;
        case 2:
            vec = vec.rotate(-angle).mult(vFilter.x, vFilter.y).rotate(angle);
            var rVec = vec.rotate(-angle).mult(factor, factor);
            height = this.refHeight - rVec.y;
            if (shiftMode) width = height*im.aspectRatio;
            else width = this.refWidth;
            break;
        case 3:
            var dir = diagDir.rotate(-angle).mult(1,-1);
            if(shiftMode) vec = dir.mult(vec.dot(dir) / dir.dot(dir));
            var rVec = vec.rotate(-angle).mult(factor, factor);
            width = this.refWidth + rVec.x;
            height = this.refHeight - rVec.y;
            break;
        case 4:
            vec = vec.rotate(-angle).mult(hFilter.x, hFilter.y).rotate(angle);
            var rVec = vec.rotate(-angle).mult(factor, factor);
            width = this.refWidth - rVec.x;
            if (shiftMode) height = width/im.aspectRatio;
            else height = this.refHeight;
            break;
        case 5:
            posOnly = true;
            break;
        case 6:
            vec = vec.rotate(-angle).mult(hFilter.x, hFilter.y).rotate(angle);
            var rVec = vec.rotate(-angle).mult(factor, factor);
            width = this.refWidth + rVec.x;
            if (shiftMode) height = width/im.aspectRatio;
            else height = this.refHeight;
            break;
        case 7:
            var dir = diagDir.rotate(-angle).mult(-1,1);
            if(shiftMode) vec = dir.mult(vec.dot(dir) / dir.dot(dir));
            var rVec = vec.rotate(-angle).mult(factor, factor);
            width = this.refWidth - rVec.x;
            height = this.refHeight + rVec.y;
            break;
        case 8:
            vec = vec.rotate(-angle).mult(vFilter.x, vFilter.y).rotate(angle);
            var rVec = vec.rotate(-angle).mult(factor, factor);
            height = this.refHeight + rVec.y;
            if (shiftMode) width = height*im.aspectRatio;
            else width = this.refWidth;
            break;
        case 9:
            var dir = diagDir.rotate(angle).mult(1,1);
            if(shiftMode) vec = dir.mult(vec.dot(dir) / dir.dot(dir));
            var rVec = vec.rotate(-angle).mult(factor, factor);
            width = this.refWidth + rVec.x;
            height = this.refHeight + rVec.y;
            break;
        default:
            throw new Error("unknown handle index!");
    }

    var pos = this.refPos;
    if(!posOnly && !centerMode) {
        pos = this.refPos.add(vec.mult(1/2));
    } else if (posOnly) {
        pos = this.refPos.add(vec);
    }
    var xflip = Math.sign(width) === -1 ? true : false;
    var yflip = Math.sign(height) === -1 ? true : false;
    this.gridInteractionModel.updateGrid(pos, Math.abs(width), Math.abs(height), xflip, yflip);
};

GridInteractionHandle.prototype.onElementMovingStop = function() {
    this.gridInteractionModel.handleMoving = false;
    this.gridInteractionModel.update();
};

GridInteractionHandle.prototype.doubleClickAction = function () {
};

GridInteractionHandle.prototype.remove = function () {
};
